/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "traverse";

export enum Ordering {
  DEFAULT = 0,
  ASC = 1,
  DESC = 2,
  UNRECOGNIZED = -1,
}

export function orderingFromJSON(object: any): Ordering {
  switch (object) {
    case 0:
    case "DEFAULT":
      return Ordering.DEFAULT;
    case 1:
    case "ASC":
      return Ordering.ASC;
    case 2:
    case "DESC":
      return Ordering.DESC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Ordering.UNRECOGNIZED;
  }
}

export function orderingToJSON(object: Ordering): string {
  switch (object) {
    case Ordering.DEFAULT:
      return "DEFAULT";
    case Ordering.ASC:
      return "ASC";
    case Ordering.DESC:
      return "DESC";
    default:
      return "UNKNOWN";
  }
}

export interface ErrorResponse {
  error: Error | undefined;
}

export interface Error {
  statusCode: number;
  message: string;
}

export interface EmptyRequest {
  token: string;
}

export interface EmailRequest {
  token: string;
  email: string;
}

export interface IdRequest {
  token: string;
  id: number;
}

export interface IdListRequest {
  token: string;
  ids: number[];
}

export interface QueryRequest {
  token: string;
  limit: number;
  offset: number;
  deltaTimestamp: Date | undefined;
  search: string;
  ordering: Ordering;
  orderRestraintsBy: QueryRequest_RestraintOrderOptions;
  orderCovidPatientsBy: QueryRequest_COVIDPatientOrderOptions;
  orderCovidTestLocationsBy: QueryRequest_COVIDTestLocationsOrderOptions;
  orderCovidTestsBy: QueryRequest_COVIDTestOrderOptions;
  orderInvoicesBy: QueryRequest_COVIDInvoiceOrderOptions;
  covidPatientTypeFilter: QueryRequest_COVIDPatientTypeFilter;
  untestedThisWeek: boolean;
  accountId: number;
}

export enum QueryRequest_COVIDPatientTypeFilter {
  ALL = 0,
  CONTRACTORS = 1,
  INTERNAL = 2,
  UNRECOGNIZED = -1,
}

export function queryRequest_COVIDPatientTypeFilterFromJSON(
  object: any
): QueryRequest_COVIDPatientTypeFilter {
  switch (object) {
    case 0:
    case "ALL":
      return QueryRequest_COVIDPatientTypeFilter.ALL;
    case 1:
    case "CONTRACTORS":
      return QueryRequest_COVIDPatientTypeFilter.CONTRACTORS;
    case 2:
    case "INTERNAL":
      return QueryRequest_COVIDPatientTypeFilter.INTERNAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QueryRequest_COVIDPatientTypeFilter.UNRECOGNIZED;
  }
}

export function queryRequest_COVIDPatientTypeFilterToJSON(
  object: QueryRequest_COVIDPatientTypeFilter
): string {
  switch (object) {
    case QueryRequest_COVIDPatientTypeFilter.ALL:
      return "ALL";
    case QueryRequest_COVIDPatientTypeFilter.CONTRACTORS:
      return "CONTRACTORS";
    case QueryRequest_COVIDPatientTypeFilter.INTERNAL:
      return "INTERNAL";
    default:
      return "UNKNOWN";
  }
}

export enum QueryRequest_RestraintOrderOptions {
  DEFAULT = 0,
  COMPLY_SN = 1,
  RESTRAINT_SN = 2,
  RESTRAINT_TYPE = 3,
  LENGTH = 4,
  LOCATION = 5,
  SCAN_DATE = 6,
  STATUS = 7,
  UNRECOGNIZED = -1,
}

export function queryRequest_RestraintOrderOptionsFromJSON(
  object: any
): QueryRequest_RestraintOrderOptions {
  switch (object) {
    case 0:
    case "DEFAULT":
      return QueryRequest_RestraintOrderOptions.DEFAULT;
    case 1:
    case "COMPLY_SN":
      return QueryRequest_RestraintOrderOptions.COMPLY_SN;
    case 2:
    case "RESTRAINT_SN":
      return QueryRequest_RestraintOrderOptions.RESTRAINT_SN;
    case 3:
    case "RESTRAINT_TYPE":
      return QueryRequest_RestraintOrderOptions.RESTRAINT_TYPE;
    case 4:
    case "LENGTH":
      return QueryRequest_RestraintOrderOptions.LENGTH;
    case 5:
    case "LOCATION":
      return QueryRequest_RestraintOrderOptions.LOCATION;
    case 6:
    case "SCAN_DATE":
      return QueryRequest_RestraintOrderOptions.SCAN_DATE;
    case 7:
    case "STATUS":
      return QueryRequest_RestraintOrderOptions.STATUS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QueryRequest_RestraintOrderOptions.UNRECOGNIZED;
  }
}

export function queryRequest_RestraintOrderOptionsToJSON(
  object: QueryRequest_RestraintOrderOptions
): string {
  switch (object) {
    case QueryRequest_RestraintOrderOptions.DEFAULT:
      return "DEFAULT";
    case QueryRequest_RestraintOrderOptions.COMPLY_SN:
      return "COMPLY_SN";
    case QueryRequest_RestraintOrderOptions.RESTRAINT_SN:
      return "RESTRAINT_SN";
    case QueryRequest_RestraintOrderOptions.RESTRAINT_TYPE:
      return "RESTRAINT_TYPE";
    case QueryRequest_RestraintOrderOptions.LENGTH:
      return "LENGTH";
    case QueryRequest_RestraintOrderOptions.LOCATION:
      return "LOCATION";
    case QueryRequest_RestraintOrderOptions.SCAN_DATE:
      return "SCAN_DATE";
    case QueryRequest_RestraintOrderOptions.STATUS:
      return "STATUS";
    default:
      return "UNKNOWN";
  }
}

export enum QueryRequest_COVIDPatientOrderOptions {
  CT_DEFAULT = 0,
  CT_LAST_NAME = 1,
  CT_FIRST_NAME = 2,
  CT_EMAIL = 3,
  CT_DOB = 4,
  CT_SEX = 5,
  CT_RACE = 6,
  CT_COMPANY = 7,
  UNRECOGNIZED = -1,
}

export function queryRequest_COVIDPatientOrderOptionsFromJSON(
  object: any
): QueryRequest_COVIDPatientOrderOptions {
  switch (object) {
    case 0:
    case "CT_DEFAULT":
      return QueryRequest_COVIDPatientOrderOptions.CT_DEFAULT;
    case 1:
    case "CT_LAST_NAME":
      return QueryRequest_COVIDPatientOrderOptions.CT_LAST_NAME;
    case 2:
    case "CT_FIRST_NAME":
      return QueryRequest_COVIDPatientOrderOptions.CT_FIRST_NAME;
    case 3:
    case "CT_EMAIL":
      return QueryRequest_COVIDPatientOrderOptions.CT_EMAIL;
    case 4:
    case "CT_DOB":
      return QueryRequest_COVIDPatientOrderOptions.CT_DOB;
    case 5:
    case "CT_SEX":
      return QueryRequest_COVIDPatientOrderOptions.CT_SEX;
    case 6:
    case "CT_RACE":
      return QueryRequest_COVIDPatientOrderOptions.CT_RACE;
    case 7:
    case "CT_COMPANY":
      return QueryRequest_COVIDPatientOrderOptions.CT_COMPANY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QueryRequest_COVIDPatientOrderOptions.UNRECOGNIZED;
  }
}

export function queryRequest_COVIDPatientOrderOptionsToJSON(
  object: QueryRequest_COVIDPatientOrderOptions
): string {
  switch (object) {
    case QueryRequest_COVIDPatientOrderOptions.CT_DEFAULT:
      return "CT_DEFAULT";
    case QueryRequest_COVIDPatientOrderOptions.CT_LAST_NAME:
      return "CT_LAST_NAME";
    case QueryRequest_COVIDPatientOrderOptions.CT_FIRST_NAME:
      return "CT_FIRST_NAME";
    case QueryRequest_COVIDPatientOrderOptions.CT_EMAIL:
      return "CT_EMAIL";
    case QueryRequest_COVIDPatientOrderOptions.CT_DOB:
      return "CT_DOB";
    case QueryRequest_COVIDPatientOrderOptions.CT_SEX:
      return "CT_SEX";
    case QueryRequest_COVIDPatientOrderOptions.CT_RACE:
      return "CT_RACE";
    case QueryRequest_COVIDPatientOrderOptions.CT_COMPANY:
      return "CT_COMPANY";
    default:
      return "UNKNOWN";
  }
}

export enum QueryRequest_COVIDTestOrderOptions {
  CTS_FIRST_NAME = 0,
  CTS_LAST_NAME = 1,
  CTS_COMPANY = 2,
  CTS_TEST_RESULT = 3,
  CTS_TEST_DATE = 4,
  CTS_BILLED = 5,
  UNRECOGNIZED = -1,
}

export function queryRequest_COVIDTestOrderOptionsFromJSON(
  object: any
): QueryRequest_COVIDTestOrderOptions {
  switch (object) {
    case 0:
    case "CTS_FIRST_NAME":
      return QueryRequest_COVIDTestOrderOptions.CTS_FIRST_NAME;
    case 1:
    case "CTS_LAST_NAME":
      return QueryRequest_COVIDTestOrderOptions.CTS_LAST_NAME;
    case 2:
    case "CTS_COMPANY":
      return QueryRequest_COVIDTestOrderOptions.CTS_COMPANY;
    case 3:
    case "CTS_TEST_RESULT":
      return QueryRequest_COVIDTestOrderOptions.CTS_TEST_RESULT;
    case 4:
    case "CTS_TEST_DATE":
      return QueryRequest_COVIDTestOrderOptions.CTS_TEST_DATE;
    case 5:
    case "CTS_BILLED":
      return QueryRequest_COVIDTestOrderOptions.CTS_BILLED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QueryRequest_COVIDTestOrderOptions.UNRECOGNIZED;
  }
}

export function queryRequest_COVIDTestOrderOptionsToJSON(
  object: QueryRequest_COVIDTestOrderOptions
): string {
  switch (object) {
    case QueryRequest_COVIDTestOrderOptions.CTS_FIRST_NAME:
      return "CTS_FIRST_NAME";
    case QueryRequest_COVIDTestOrderOptions.CTS_LAST_NAME:
      return "CTS_LAST_NAME";
    case QueryRequest_COVIDTestOrderOptions.CTS_COMPANY:
      return "CTS_COMPANY";
    case QueryRequest_COVIDTestOrderOptions.CTS_TEST_RESULT:
      return "CTS_TEST_RESULT";
    case QueryRequest_COVIDTestOrderOptions.CTS_TEST_DATE:
      return "CTS_TEST_DATE";
    case QueryRequest_COVIDTestOrderOptions.CTS_BILLED:
      return "CTS_BILLED";
    default:
      return "UNKNOWN";
  }
}

export enum QueryRequest_COVIDTestLocationsOrderOptions {
  CTL_LOCATION = 0,
  CTL_TEST_DATE = 1,
  CTL_TESTS_ADMINISTERED = 2,
  CTL_POSITIVE_COUNT = 3,
  UNRECOGNIZED = -1,
}

export function queryRequest_COVIDTestLocationsOrderOptionsFromJSON(
  object: any
): QueryRequest_COVIDTestLocationsOrderOptions {
  switch (object) {
    case 0:
    case "CTL_LOCATION":
      return QueryRequest_COVIDTestLocationsOrderOptions.CTL_LOCATION;
    case 1:
    case "CTL_TEST_DATE":
      return QueryRequest_COVIDTestLocationsOrderOptions.CTL_TEST_DATE;
    case 2:
    case "CTL_TESTS_ADMINISTERED":
      return QueryRequest_COVIDTestLocationsOrderOptions.CTL_TESTS_ADMINISTERED;
    case 3:
    case "CTL_POSITIVE_COUNT":
      return QueryRequest_COVIDTestLocationsOrderOptions.CTL_POSITIVE_COUNT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QueryRequest_COVIDTestLocationsOrderOptions.UNRECOGNIZED;
  }
}

export function queryRequest_COVIDTestLocationsOrderOptionsToJSON(
  object: QueryRequest_COVIDTestLocationsOrderOptions
): string {
  switch (object) {
    case QueryRequest_COVIDTestLocationsOrderOptions.CTL_LOCATION:
      return "CTL_LOCATION";
    case QueryRequest_COVIDTestLocationsOrderOptions.CTL_TEST_DATE:
      return "CTL_TEST_DATE";
    case QueryRequest_COVIDTestLocationsOrderOptions.CTL_TESTS_ADMINISTERED:
      return "CTL_TESTS_ADMINISTERED";
    case QueryRequest_COVIDTestLocationsOrderOptions.CTL_POSITIVE_COUNT:
      return "CTL_POSITIVE_COUNT";
    default:
      return "UNKNOWN";
  }
}

export enum QueryRequest_COVIDInvoiceOrderOptions {
  CTI_INVOICE_ID = 0,
  CTI_INVOICE_TYPE = 1,
  CTI_BILLED_TO = 2,
  CTI_INVOICE_AMOUNT = 3,
  UNRECOGNIZED = -1,
}

export function queryRequest_COVIDInvoiceOrderOptionsFromJSON(
  object: any
): QueryRequest_COVIDInvoiceOrderOptions {
  switch (object) {
    case 0:
    case "CTI_INVOICE_ID":
      return QueryRequest_COVIDInvoiceOrderOptions.CTI_INVOICE_ID;
    case 1:
    case "CTI_INVOICE_TYPE":
      return QueryRequest_COVIDInvoiceOrderOptions.CTI_INVOICE_TYPE;
    case 2:
    case "CTI_BILLED_TO":
      return QueryRequest_COVIDInvoiceOrderOptions.CTI_BILLED_TO;
    case 3:
    case "CTI_INVOICE_AMOUNT":
      return QueryRequest_COVIDInvoiceOrderOptions.CTI_INVOICE_AMOUNT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return QueryRequest_COVIDInvoiceOrderOptions.UNRECOGNIZED;
  }
}

export function queryRequest_COVIDInvoiceOrderOptionsToJSON(
  object: QueryRequest_COVIDInvoiceOrderOptions
): string {
  switch (object) {
    case QueryRequest_COVIDInvoiceOrderOptions.CTI_INVOICE_ID:
      return "CTI_INVOICE_ID";
    case QueryRequest_COVIDInvoiceOrderOptions.CTI_INVOICE_TYPE:
      return "CTI_INVOICE_TYPE";
    case QueryRequest_COVIDInvoiceOrderOptions.CTI_BILLED_TO:
      return "CTI_BILLED_TO";
    case QueryRequest_COVIDInvoiceOrderOptions.CTI_INVOICE_AMOUNT:
      return "CTI_INVOICE_AMOUNT";
    default:
      return "UNKNOWN";
  }
}

/** Represents an amount of money with its currency type. */
export interface Money {
  /** The 3-letter currency code defined in ISO 4217. */
  currencyCode: string;
  /**
   * The whole units of the amount.
   * For example if `currencyCode` is `"USD"`, then 1 unit is one US dollar.
   */
  units: number;
  /**
   * Number of nano (10^-9) units of the amount.
   * The value must be between -999,999,999 and +999,999,999 inclusive.
   * If `units` is positive, `nanos` must be positive or zero.
   * If `units` is zero, `nanos` can be positive, zero, or negative.
   * If `units` is negative, `nanos` must be negative or zero.
   * For example $-1.75 is represented as `units`=-1 and `nanos`=-750,000,000.
   */
  nanos: number;
}

export interface ProvisionedURLResponse {
  error: Error | undefined;
  uploadURL: string;
}

export interface ProvisionAttachmentRequest {
  token: string;
  fileType: string;
  id: number;
}

const baseErrorResponse: object = {};

export const ErrorResponse = {
  encode(
    message: ErrorResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ErrorResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseErrorResponse } as ErrorResponse;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.error = Error.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): ErrorResponse {
    const message = { ...baseErrorResponse } as ErrorResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromJSON(object.error)
        : undefined;
    return message;
  },

  toJSON(message: ErrorResponse): unknown {
    const obj: any = {};
    message.error !== undefined &&
      (obj.error = message.error ? Error.toJSON(message.error) : undefined);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<ErrorResponse>, I>>(
    object: I
  ): ErrorResponse {
    const message = { ...baseErrorResponse } as ErrorResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromPartial(object.error)
        : undefined;
    return message;
  },
};

const baseError: object = { statusCode: 0, message: "" };

export const Error = {
  encode(message: Error, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.statusCode !== 0) {
      writer.uint32(8).int32(message.statusCode);
    }
    if (message.message !== "") {
      writer.uint32(18).string(message.message);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Error {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseError } as Error;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.statusCode = reader.int32();
          break;
        case 2:
          message.message = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): Error {
    const message = { ...baseError } as Error;
    message.statusCode =
      object.statusCode !== undefined && object.statusCode !== null
        ? Number(object.statusCode)
        : 0;
    message.message =
      object.message !== undefined && object.message !== null
        ? String(object.message)
        : "";
    return message;
  },

  toJSON(message: Error): unknown {
    const obj: any = {};
    message.statusCode !== undefined && (obj.statusCode = message.statusCode);
    message.message !== undefined && (obj.message = message.message);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<Error>, I>>(object: I): Error {
    const message = { ...baseError } as Error;
    message.statusCode = object.statusCode ?? 0;
    message.message = object.message ?? "";
    return message;
  },
};

const baseEmptyRequest: object = { token: "" };

export const EmptyRequest = {
  encode(
    message: EmptyRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EmptyRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseEmptyRequest } as EmptyRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.token = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): EmptyRequest {
    const message = { ...baseEmptyRequest } as EmptyRequest;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    return message;
  },

  toJSON(message: EmptyRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<EmptyRequest>, I>>(
    object: I
  ): EmptyRequest {
    const message = { ...baseEmptyRequest } as EmptyRequest;
    message.token = object.token ?? "";
    return message;
  },
};

const baseEmailRequest: object = { token: "", email: "" };

export const EmailRequest = {
  encode(
    message: EmailRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    if (message.email !== "") {
      writer.uint32(18).string(message.email);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EmailRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseEmailRequest } as EmailRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.token = reader.string();
          break;
        case 2:
          message.email = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): EmailRequest {
    const message = { ...baseEmailRequest } as EmailRequest;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    message.email =
      object.email !== undefined && object.email !== null
        ? String(object.email)
        : "";
    return message;
  },

  toJSON(message: EmailRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    message.email !== undefined && (obj.email = message.email);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<EmailRequest>, I>>(
    object: I
  ): EmailRequest {
    const message = { ...baseEmailRequest } as EmailRequest;
    message.token = object.token ?? "";
    message.email = object.email ?? "";
    return message;
  },
};

const baseIdRequest: object = { token: "", id: 0 };

export const IdRequest = {
  encode(
    message: IdRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    if (message.id !== 0) {
      writer.uint32(16).int64(message.id);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IdRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseIdRequest } as IdRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.token = reader.string();
          break;
        case 2:
          message.id = longToNumber(reader.int64() as Long);
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): IdRequest {
    const message = { ...baseIdRequest } as IdRequest;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    message.id =
      object.id !== undefined && object.id !== null ? Number(object.id) : 0;
    return message;
  },

  toJSON(message: IdRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    message.id !== undefined && (obj.id = message.id);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<IdRequest>, I>>(
    object: I
  ): IdRequest {
    const message = { ...baseIdRequest } as IdRequest;
    message.token = object.token ?? "";
    message.id = object.id ?? 0;
    return message;
  },
};

const baseIdListRequest: object = { token: "", ids: 0 };

export const IdListRequest = {
  encode(
    message: IdListRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    writer.uint32(18).fork();
    for (const v of message.ids) {
      writer.int64(v);
    }
    writer.ldelim();
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IdListRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseIdListRequest } as IdListRequest;
    message.ids = [];
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.token = reader.string();
          break;
        case 2:
          if ((tag & 7) === 2) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.ids.push(longToNumber(reader.int64() as Long));
            }
          } else {
            message.ids.push(longToNumber(reader.int64() as Long));
          }
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): IdListRequest {
    const message = { ...baseIdListRequest } as IdListRequest;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    message.ids = (object.ids ?? []).map((e: any) => Number(e));
    return message;
  },

  toJSON(message: IdListRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    if (message.ids) {
      obj.ids = message.ids.map((e) => e);
    } else {
      obj.ids = [];
    }
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<IdListRequest>, I>>(
    object: I
  ): IdListRequest {
    const message = { ...baseIdListRequest } as IdListRequest;
    message.token = object.token ?? "";
    message.ids = object.ids?.map((e) => e) || [];
    return message;
  },
};

const baseQueryRequest: object = {
  token: "",
  limit: 0,
  offset: 0,
  search: "",
  ordering: 0,
  orderRestraintsBy: 0,
  orderCovidPatientsBy: 0,
  orderCovidTestLocationsBy: 0,
  orderCovidTestsBy: 0,
  orderInvoicesBy: 0,
  covidPatientTypeFilter: 0,
  untestedThisWeek: false,
  accountId: 0,
};

export const QueryRequest = {
  encode(
    message: QueryRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    if (message.limit !== 0) {
      writer.uint32(16).int64(message.limit);
    }
    if (message.offset !== 0) {
      writer.uint32(24).int64(message.offset);
    }
    if (message.deltaTimestamp !== undefined) {
      Timestamp.encode(
        toTimestamp(message.deltaTimestamp),
        writer.uint32(34).fork()
      ).ldelim();
    }
    if (message.search !== "") {
      writer.uint32(42).string(message.search);
    }
    if (message.ordering !== 0) {
      writer.uint32(48).int32(message.ordering);
    }
    if (message.orderRestraintsBy !== 0) {
      writer.uint32(56).int32(message.orderRestraintsBy);
    }
    if (message.orderCovidPatientsBy !== 0) {
      writer.uint32(64).int32(message.orderCovidPatientsBy);
    }
    if (message.orderCovidTestLocationsBy !== 0) {
      writer.uint32(72).int32(message.orderCovidTestLocationsBy);
    }
    if (message.orderCovidTestsBy !== 0) {
      writer.uint32(88).int32(message.orderCovidTestsBy);
    }
    if (message.orderInvoicesBy !== 0) {
      writer.uint32(80).int32(message.orderInvoicesBy);
    }
    if (message.covidPatientTypeFilter !== 0) {
      writer.uint32(112).int32(message.covidPatientTypeFilter);
    }
    if (message.untestedThisWeek === true) {
      writer.uint32(104).bool(message.untestedThisWeek);
    }
    if (message.accountId !== 0) {
      writer.uint32(120).int64(message.accountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): QueryRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseQueryRequest } as QueryRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.token = reader.string();
          break;
        case 2:
          message.limit = longToNumber(reader.int64() as Long);
          break;
        case 3:
          message.offset = longToNumber(reader.int64() as Long);
          break;
        case 4:
          message.deltaTimestamp = fromTimestamp(
            Timestamp.decode(reader, reader.uint32())
          );
          break;
        case 5:
          message.search = reader.string();
          break;
        case 6:
          message.ordering = reader.int32() as any;
          break;
        case 7:
          message.orderRestraintsBy = reader.int32() as any;
          break;
        case 8:
          message.orderCovidPatientsBy = reader.int32() as any;
          break;
        case 9:
          message.orderCovidTestLocationsBy = reader.int32() as any;
          break;
        case 11:
          message.orderCovidTestsBy = reader.int32() as any;
          break;
        case 10:
          message.orderInvoicesBy = reader.int32() as any;
          break;
        case 14:
          message.covidPatientTypeFilter = reader.int32() as any;
          break;
        case 13:
          message.untestedThisWeek = reader.bool();
          break;
        case 15:
          message.accountId = longToNumber(reader.int64() as Long);
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): QueryRequest {
    const message = { ...baseQueryRequest } as QueryRequest;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    message.limit =
      object.limit !== undefined && object.limit !== null
        ? Number(object.limit)
        : 0;
    message.offset =
      object.offset !== undefined && object.offset !== null
        ? Number(object.offset)
        : 0;
    message.deltaTimestamp =
      object.deltaTimestamp !== undefined && object.deltaTimestamp !== null
        ? fromJsonTimestamp(object.deltaTimestamp)
        : undefined;
    message.search =
      object.search !== undefined && object.search !== null
        ? String(object.search)
        : "";
    message.ordering =
      object.ordering !== undefined && object.ordering !== null
        ? orderingFromJSON(object.ordering)
        : 0;
    message.orderRestraintsBy =
      object.orderRestraintsBy !== undefined &&
      object.orderRestraintsBy !== null
        ? queryRequest_RestraintOrderOptionsFromJSON(object.orderRestraintsBy)
        : 0;
    message.orderCovidPatientsBy =
      object.orderCovidPatientsBy !== undefined &&
      object.orderCovidPatientsBy !== null
        ? queryRequest_COVIDPatientOrderOptionsFromJSON(
            object.orderCovidPatientsBy
          )
        : 0;
    message.orderCovidTestLocationsBy =
      object.orderCovidTestLocationsBy !== undefined &&
      object.orderCovidTestLocationsBy !== null
        ? queryRequest_COVIDTestLocationsOrderOptionsFromJSON(
            object.orderCovidTestLocationsBy
          )
        : 0;
    message.orderCovidTestsBy =
      object.orderCovidTestsBy !== undefined &&
      object.orderCovidTestsBy !== null
        ? queryRequest_COVIDTestOrderOptionsFromJSON(object.orderCovidTestsBy)
        : 0;
    message.orderInvoicesBy =
      object.orderInvoicesBy !== undefined && object.orderInvoicesBy !== null
        ? queryRequest_COVIDInvoiceOrderOptionsFromJSON(object.orderInvoicesBy)
        : 0;
    message.covidPatientTypeFilter =
      object.covidPatientTypeFilter !== undefined &&
      object.covidPatientTypeFilter !== null
        ? queryRequest_COVIDPatientTypeFilterFromJSON(
            object.covidPatientTypeFilter
          )
        : 0;
    message.untestedThisWeek =
      object.untestedThisWeek !== undefined && object.untestedThisWeek !== null
        ? Boolean(object.untestedThisWeek)
        : false;
    message.accountId =
      object.accountId !== undefined && object.accountId !== null
        ? Number(object.accountId)
        : 0;
    return message;
  },

  toJSON(message: QueryRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    message.limit !== undefined && (obj.limit = message.limit);
    message.offset !== undefined && (obj.offset = message.offset);
    message.deltaTimestamp !== undefined &&
      (obj.deltaTimestamp = message.deltaTimestamp.toISOString());
    message.search !== undefined && (obj.search = message.search);
    message.ordering !== undefined &&
      (obj.ordering = orderingToJSON(message.ordering));
    message.orderRestraintsBy !== undefined &&
      (obj.orderRestraintsBy = queryRequest_RestraintOrderOptionsToJSON(
        message.orderRestraintsBy
      ));
    message.orderCovidPatientsBy !== undefined &&
      (obj.orderCovidPatientsBy = queryRequest_COVIDPatientOrderOptionsToJSON(
        message.orderCovidPatientsBy
      ));
    message.orderCovidTestLocationsBy !== undefined &&
      (obj.orderCovidTestLocationsBy =
        queryRequest_COVIDTestLocationsOrderOptionsToJSON(
          message.orderCovidTestLocationsBy
        ));
    message.orderCovidTestsBy !== undefined &&
      (obj.orderCovidTestsBy = queryRequest_COVIDTestOrderOptionsToJSON(
        message.orderCovidTestsBy
      ));
    message.orderInvoicesBy !== undefined &&
      (obj.orderInvoicesBy = queryRequest_COVIDInvoiceOrderOptionsToJSON(
        message.orderInvoicesBy
      ));
    message.covidPatientTypeFilter !== undefined &&
      (obj.covidPatientTypeFilter = queryRequest_COVIDPatientTypeFilterToJSON(
        message.covidPatientTypeFilter
      ));
    message.untestedThisWeek !== undefined &&
      (obj.untestedThisWeek = message.untestedThisWeek);
    message.accountId !== undefined && (obj.accountId = message.accountId);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<QueryRequest>, I>>(
    object: I
  ): QueryRequest {
    const message = { ...baseQueryRequest } as QueryRequest;
    message.token = object.token ?? "";
    message.limit = object.limit ?? 0;
    message.offset = object.offset ?? 0;
    message.deltaTimestamp = object.deltaTimestamp ?? undefined;
    message.search = object.search ?? "";
    message.ordering = object.ordering ?? 0;
    message.orderRestraintsBy = object.orderRestraintsBy ?? 0;
    message.orderCovidPatientsBy = object.orderCovidPatientsBy ?? 0;
    message.orderCovidTestLocationsBy = object.orderCovidTestLocationsBy ?? 0;
    message.orderCovidTestsBy = object.orderCovidTestsBy ?? 0;
    message.orderInvoicesBy = object.orderInvoicesBy ?? 0;
    message.covidPatientTypeFilter = object.covidPatientTypeFilter ?? 0;
    message.untestedThisWeek = object.untestedThisWeek ?? false;
    message.accountId = object.accountId ?? 0;
    return message;
  },
};

const baseMoney: object = { currencyCode: "", units: 0, nanos: 0 };

export const Money = {
  encode(message: Money, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.currencyCode !== "") {
      writer.uint32(10).string(message.currencyCode);
    }
    if (message.units !== 0) {
      writer.uint32(16).int64(message.units);
    }
    if (message.nanos !== 0) {
      writer.uint32(24).int32(message.nanos);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Money {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseMoney } as Money;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.currencyCode = reader.string();
          break;
        case 2:
          message.units = longToNumber(reader.int64() as Long);
          break;
        case 3:
          message.nanos = reader.int32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): Money {
    const message = { ...baseMoney } as Money;
    message.currencyCode =
      object.currencyCode !== undefined && object.currencyCode !== null
        ? String(object.currencyCode)
        : "";
    message.units =
      object.units !== undefined && object.units !== null
        ? Number(object.units)
        : 0;
    message.nanos =
      object.nanos !== undefined && object.nanos !== null
        ? Number(object.nanos)
        : 0;
    return message;
  },

  toJSON(message: Money): unknown {
    const obj: any = {};
    message.currencyCode !== undefined &&
      (obj.currencyCode = message.currencyCode);
    message.units !== undefined && (obj.units = message.units);
    message.nanos !== undefined && (obj.nanos = message.nanos);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<Money>, I>>(object: I): Money {
    const message = { ...baseMoney } as Money;
    message.currencyCode = object.currencyCode ?? "";
    message.units = object.units ?? 0;
    message.nanos = object.nanos ?? 0;
    return message;
  },
};

const baseProvisionedURLResponse: object = { uploadURL: "" };

export const ProvisionedURLResponse = {
  encode(
    message: ProvisionedURLResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.error !== undefined) {
      Error.encode(message.error, writer.uint32(10).fork()).ldelim();
    }
    if (message.uploadURL !== "") {
      writer.uint32(18).string(message.uploadURL);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): ProvisionedURLResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = { ...baseProvisionedURLResponse } as ProvisionedURLResponse;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.error = Error.decode(reader, reader.uint32());
          break;
        case 2:
          message.uploadURL = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): ProvisionedURLResponse {
    const message = { ...baseProvisionedURLResponse } as ProvisionedURLResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromJSON(object.error)
        : undefined;
    message.uploadURL =
      object.uploadURL !== undefined && object.uploadURL !== null
        ? String(object.uploadURL)
        : "";
    return message;
  },

  toJSON(message: ProvisionedURLResponse): unknown {
    const obj: any = {};
    message.error !== undefined &&
      (obj.error = message.error ? Error.toJSON(message.error) : undefined);
    message.uploadURL !== undefined && (obj.uploadURL = message.uploadURL);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<ProvisionedURLResponse>, I>>(
    object: I
  ): ProvisionedURLResponse {
    const message = { ...baseProvisionedURLResponse } as ProvisionedURLResponse;
    message.error =
      object.error !== undefined && object.error !== null
        ? Error.fromPartial(object.error)
        : undefined;
    message.uploadURL = object.uploadURL ?? "";
    return message;
  },
};

const baseProvisionAttachmentRequest: object = {
  token: "",
  fileType: "",
  id: 0,
};

export const ProvisionAttachmentRequest = {
  encode(
    message: ProvisionAttachmentRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.token !== "") {
      writer.uint32(10).string(message.token);
    }
    if (message.fileType !== "") {
      writer.uint32(18).string(message.fileType);
    }
    if (message.id !== 0) {
      writer.uint32(24).int64(message.id);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): ProvisionAttachmentRequest {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseProvisionAttachmentRequest,
    } as ProvisionAttachmentRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.token = reader.string();
          break;
        case 2:
          message.fileType = reader.string();
          break;
        case 3:
          message.id = longToNumber(reader.int64() as Long);
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): ProvisionAttachmentRequest {
    const message = {
      ...baseProvisionAttachmentRequest,
    } as ProvisionAttachmentRequest;
    message.token =
      object.token !== undefined && object.token !== null
        ? String(object.token)
        : "";
    message.fileType =
      object.fileType !== undefined && object.fileType !== null
        ? String(object.fileType)
        : "";
    message.id =
      object.id !== undefined && object.id !== null ? Number(object.id) : 0;
    return message;
  },

  toJSON(message: ProvisionAttachmentRequest): unknown {
    const obj: any = {};
    message.token !== undefined && (obj.token = message.token);
    message.fileType !== undefined && (obj.fileType = message.fileType);
    message.id !== undefined && (obj.id = message.id);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<ProvisionAttachmentRequest>, I>>(
    object: I
  ): ProvisionAttachmentRequest {
    const message = {
      ...baseProvisionAttachmentRequest,
    } as ProvisionAttachmentRequest;
    message.token = object.token ?? "";
    message.fileType = object.fileType ?? "";
    message.id = object.id ?? 0;
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<
        Exclude<keyof I, KeysOfUnion<P>>,
        never
      >;

function toTimestamp(date: Date): Timestamp {
  const seconds = date.getTime() / 1_000;
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = t.seconds * 1_000;
  millis += t.nanos / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}
